import React from 'react';
import { Dialog as IronDialog } from 'iron-man';
import { createRoot } from 'react-dom/client';
import { debounce } from '@fe-util/common';
import './index.less';

// 创建容器
const getContainer = () => {
  let el = document.getElementById('aia-bx-dialog');
  if (el === null) {
    el = document.createElement('div');
    document.body.append(el);
    el.id = 'aia-bx-dialog';
  }
  return el;
};
const Dialog = debounce((props) => {
  const { onCancel, onClose, onOk, id } = props;
  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
    root.unmount();
  };
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    root.unmount();
  };
  const handleOk = () => {
    if (onOk) {
      onOk();
    }
    root.unmount();
  };

  const root = createRoot(getContainer());

  root.render(
    <div className="bx-preAuth-message-dialog">
      <IronDialog
        {...props}
        id={id}
        isOpen
        onCancel={handleCancel}
        onClose={handleClose}
        onOk={handleOk}
      ></IronDialog>
    </div>
  );
}, 1000);

export default Dialog;
